/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import { userDetail } from 'Stores/userDetail';
import { makeApi, URLS } from '../../utils/apiUtil';
import googleSheetDashboardIcon from '../../../assets/dashboard/googleSheet/adaptSeeker.png';
import SeekerEmptyIcon from '../../../assets/png/seeker-empty.png';
import { ReactComponent as CompletedIcon } from '../../../assets/svg/seeker-completed.svg';
import { ReactComponent as StoppedIcon } from '../../../assets/svg/seeker-stopped.svg';
import { ReactComponent as InProgressIcon } from '../../../assets/svg/seeker-in-progress.svg';
import { SeekerNewListPopup, seekerNewListState } from './seekerNewList';

const SeekerRightComponent = observer(props => {
  const [allUploadedList, setAllUploadedList] = React.useState({});
  const [showLoading, setShowLoading] = React.useState(false);

  const { userInfo, featureFlags } = userDetail;
  const { memberId, views, lbCredits, memberSubscription = null } = userInfo;
  const { SEEKER = false } = featureFlags;

  const getUploadedListData = () => {
    const config = {
      url: URLS.getAllUploadedEnricherList
        ? URLS.getAllUploadedEnricherList
        : '',
      method: 'GET',
    };
    makeApi(config)
      .then(response => {
        if (response && response.data) setAllUploadedList(response.data);
      })
      .catch(error => {
        console.log('All Uploaded List Data error ', error);
      });
  };

  const googleAddonBtnClick = () => {
    window.open(
      'https://workspace.google.com/u/0/marketplace/app/adapt_seeker_email_finder/418593827117?hl=en&pann=sheets_addon_widget',
      '_blank',
      'noopener',
    );
  };

  const stopJob = jobId => {
    if (memberId !== undefined && jobId !== undefined) {
      const config = {
        url: `${URLS.seekerBulkJobStop}?jobId=${jobId}&memberId=${memberId}`,
        method: 'POST',
      };
      setShowLoading(true);
      makeApi(config)
        .then(response => {
          console.log('onFileUpload ', response);
          if (response && response.status === 200) getUploadedListData();
          setShowLoading(false);
        })
        .catch(error => {
          console.log('setOwnershipData error ', error);
        });
    }
  };

  const newListClick = e => {
    if (SEEKER === false) {
      console.log('pricing pop');
      Utils.showUserPricingPopup();
    } else if (
      (!Utils.isCreditBasedSubscription() && views <= 0) ||
      (Utils.isCreditBasedSubscription() &&
        (lbCredits <= 0 || !Utils.isCreditsWithinMonthlyLimit()))
    ) {
      if (memberSubscription !== null) {
        Utils.showCreditExpiredPopup('views');
      } else {
        Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_PAYWALL_PRICING_POPUP, {
          btnSource: 'Seeker - views',
        });
        Utils.showUserPricingPopup(true, 'views', false);
      }
    } else {
      const callback = () => {
        Utils.mixpanelTrack(CONSTANTS.MX_SEEKER_EVENTS.SEEKER_TASK_CREATED, {});
        getUploadedListData();
        seekerNewListState.setShowPopup(false);
      };
      seekerNewListState.setCallback(callback);
      seekerNewListState.setShowPopup(true);
    }
  };

  React.useEffect(() => {
    getUploadedListData();
  }, []);

  const { jobs = [], count = 0 } = allUploadedList;

  return (
    <>
      <SeekerNewListPopup />
      <LoadingWrapper show={showLoading} />
      {!props.isGoogleTabSelected && (
        <>
          <div className="headerCont">
            <div className="rightContent">
              {jobs.length > 0 && (
                <div className="newList">
                  <span onClick={newListClick}>New List</span>
                </div>
              )}
              {SEEKER !== false && (
                <div className="seekerRemaining">
                  {count > 0 ? (
                    <>
                      <span className="seekerRemainingMsg">
                        Seeker tasks remaining today:
                      </span>
                      <span className="seekerTaskCount">{count}</span>
                    </>
                  ) : (
                    <span className="seekerRamainingMsg">
                      You've exhausted your daily quota for Seeker
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
          {jobs.length > 0 ? (
            <div className="seekerBodyContainer">
              <table>
                <thead>
                  <tr>
                    <td className="theader-first">List Name</td>
                    <td>Records Uploaded</td>
                    <td>Records Processed</td>
                    <td>Records Failed</td>
                    <td>Status</td>
                    <td>Uploaded Date</td>
                    <td />
                  </tr>
                </thead>

                <tbody className="uploadedList">
                  {jobs.map((uploadedData, index) => {
                    if (uploadedData) {
                      let failedCount = '-';
                      let successRecordCount = '-';
                      let totalRecordsUploaded = '-';
                      let uploadedStatus = '-';
                      const listName =
                        uploadedData.data && uploadedData.data.list_name
                          ? uploadedData.data.list_name
                          : '-';
                      let downloadLink = '';
                      if (uploadedData.result) {
                        downloadLink = uploadedData.result.response_file
                          ? uploadedData.result.response_file
                          : '#';
                        failedCount = uploadedData.result.failed_count
                          ? uploadedData.result.failed_count
                          : '0';
                        successRecordCount = uploadedData.result.processed_count
                          ? uploadedData.result.processed_count
                          : '0';
                        totalRecordsUploaded = uploadedData.result.total_request
                          ? uploadedData.result.total_request
                          : '0';
                      }

                      if (uploadedData.status && uploadedData.status.length) {
                        const uploadedFileStatus = uploadedData.status
                          ? uploadedData.status.toLowerCase()
                          : '-';
                        console.log(
                          'uploadedFileStatus   ',
                          uploadedFileStatus,
                        );
                        uploadedFileStatus === 'to_be_processed' ||
                        uploadedFileStatus === 'inprogress'
                          ? (uploadedStatus = 'In Progress')
                          : uploadedFileStatus === 'processed'
                          ? (uploadedStatus = 'Completed')
                          : uploadedFileStatus === 'stopped'
                          ? (uploadedStatus = 'Stopped')
                          : '';
                      }

                      return (
                        <tr
                          key={index}
                          id={`row${index}${1}`}
                          className="uploaded-data-row"
                        >
                          <td className="uploaded-data-column column">
                            {listName}
                          </td>
                          <td className="column">{totalRecordsUploaded}</td>
                          <td className="column">{successRecordCount}</td>
                          <td className="column">{failedCount}</td>
                          <td
                            className={
                              uploadedStatus === 'Completed'
                                ? 'completed column statusColumn'
                                : uploadedStatus === 'In Progress'
                                ? 'inprogress column statusColumn'
                                : 'stopped column statusColumn'
                            }
                          >
                            <CompletedIcon className="svg-icon completed-svg" />
                            <InProgressIcon className="svg-icon progress-svg" />
                            <StoppedIcon className="svg-icon stopped-svg" />
                            {uploadedStatus}
                          </td>

                          <td className="column">-</td>
                          {uploadedStatus === 'Completed' ||
                          uploadedStatus === 'Stopped' ? (
                            <td title="Download Link" className="icon download">
                              <a
                                href={downloadLink}
                                download={downloadLink}
                                title="Download Link"
                              >
                                <i className="fa fa-download" />
                              </a>
                            </td>
                          ) : (
                            <td
                              title="Stop Job"
                              className="icon stop-circle"
                              onClick={() => stopJob(uploadedData.id)}
                            >
                              <i className="fa fa-stop-circle-o" />
                            </td>
                          )}
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="seeker-empty-job">
              <div className="empty-wrap">
                <img
                  src={SeekerEmptyIcon}
                  className="seeker-empty-icon"
                  alt="seeker empty"
                />
                Find emails from a list of names and domains. <br /> Start by
                creating a new list.
                <div className="newList">
                  <span onClick={newListClick}>Add New List</span>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {props.isGoogleTabSelected && (
        <>
          <div className="googleSheetCont">
            <div className="imageCont">
              <img src={googleSheetDashboardIcon} alt="Adapt Seeker" />
            </div>
            <div
              className="addonBtnCont"
              title="Get Addon"
              onClick={googleAddonBtnClick}
            >
              <div className="addOnBtn">Get Addon</div>
            </div>
          </div>
        </>
      )}
    </>
  );
});

export { SeekerRightComponent };
export default SeekerRightComponent;
